import React, { useState } from "react";
import { TableDateRange } from "../../common/components/TableDateRange";
import { NoRecords } from "../../common/components/NoRecords";
import { LinkEmployee } from "../Routes";
import { useQueryWithPagination } from "../../utils/Hooks";
import { AxiosEmployeeManagerAPI } from "../Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";

const EmployeeManagerTable = ({ records, ordering, setOrdering }) => {
  if (records.length === 0) {
    return (
      <NoRecords
        message={"Não existem gestores cadastrados para este funcionário!"}
      />
    );
  }

  const rows = records.map((el) => ({
    id: el.id,
    name: <LinkEmployee employee={el.manager} />,
    startDate: el.timespan.lower,
    endDate: el.timespan.upper,
    reviewAccess: el.review_access,
  }));

  return (
    <TableDateRange
      recordName={"Gestor"}
      data={rows}
      reviewAccess={true}
      ordering={ordering}
      setOrdering={setOrdering}
      nameColumn="manager"
    />
  );
};

export const EmployeeManagerList = ({ employee_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { isPending, data, error, handleNext, handlePrevious } =
    useQueryWithPagination({
      queryKey: ["employee-manager-list", employee_id, ordering],
      queryFn: AxiosEmployeeManagerAPI.getManagers,
      employee_id: employee_id,
      ordering: ordering,
    });

  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;
  if (data) {
    return (
      <>
        <EmployeeManagerTable
          records={data.results}
          ordering={ordering}
          setOrdering={setOrdering}
        />
        <PaginationButtons
          previous={data?.previous}
          next={data?.next}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      </>
    );
  }

  return null;
};
